// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#\\@vmos-vmos-flyout-app__VWkyS button{cursor:pointer}.\\@vmos-vmos-flyout-flyout-wrapper__piBkG{padding:var(--wb-spacing-s) var(--wb-spacing-s) var(--wb-spacing-s) var(--wb-spacing-s)}.\\@vmos-vmos-flyout-flyout-wrapper___spinner__Ee2En{height:32px;width:32px}@media(min-width:80em){.\\@vmos-vmos-flyout-flyout-wrapper__piBkG{padding:0}}.\\@vmos-vmos-flyout-flyout-last-level-wrapper__2Iewu{padding:var(--wb-spacing-s) 0}@media(min-width:80em){.\\@vmos-vmos-flyout-flyout-last-level-wrapper__2Iewu{padding:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app": "@vmos-vmos-flyout-app__VWkyS",
	"flyoutWrapper": "@vmos-vmos-flyout-flyout-wrapper__piBkG",
	"flyoutWrapperSpinner": "@vmos-vmos-flyout-flyout-wrapper___spinner__Ee2En",
	"flyoutLastLevelWrapper": "@vmos-vmos-flyout-flyout-last-level-wrapper__2Iewu"
};
export default ___CSS_LOADER_EXPORT___;
